export default {
  loginRegister: 'ورود | ثبت نام',
  login: 'ورود',
  register: 'ثبت نام',
  loginWithPassword: 'ورود با رمز عبور',
  otpLogin: 'ورود با رمز یکبار مصرف',
  twoStepVerification: 'تایید دو مرحله ای',
  loginDescription_html: 'سلام!<br/>لطفا شماره موبایل خود را وارد کنید',
  pleaseEnterYourPassword: 'لطفا رمز عبور خود را وارد کنید',
  forgotPassword: 'فراموشی رمز عبور',
  password: 'رمز عبور',
  otpLoginTemplate_html:
    'کد تایید برای شماره <b>{mobile}</b> پیامک شد.<br/>لطفا کد تایید را وارد کنید',
  otpCountdownTemplate: '{minutes}:{seconds} مانده تا دریافت مجدد کد',
  sendOtpCode: 'ارسال کد تایید',
  resendOtpCode: 'ارسال مجدد کد تایید',
  verificationCode: 'کد تایید',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  nationalId: 'کد ملی',
  gender: 'جنسیت',
  fatherName: 'نام پدر',
  licenseType: 'نوع گواهینامه',
  licenseNumber: 'شماره گواهینامه',
  licenseIssueTime: 'تاریخ صدور گواهینامه',
  licenseExpireTime: 'تاریخ انقضا گواهینامه',
  licenseFrontImage: 'تصویر روی گواهینامه',
  licenseBackImage: 'تصویر پشت گواهینامه',
  healthCardBackImage: 'تصویر پشت کارت سلامت',
  healthCardFrontImage: 'تصویر روی کارت سلامت',
  nationalCardBackImage: 'تصویر پشت کارت ملی',
  nationalCardFrontImage: 'تصویر روی کارت ملی',
  smartCardBackImage: 'تصویر پشت کارت هوشمند راننده',
  smartCardFrontImage: 'تصویر روی کارت هوشمند راننده',
  vehicleSmartCardBackImage: 'تصویر روی کارت هوشمند ناوگان',
  vehicleSmartCardFrontImage: 'تصویر پشت کارت هوشمند ناوگان',
  vehicleCardFrontImage: 'تصویر روی کارت شناسایی وسیله نقلیه',
  vehicleCardBackImage: 'تصویر پشت کارت شناسایی وسیله نقلیه',
  vehicleImages: 'تصویر (های) وسیله نقلیه',
  iWouldAlsoLikeToWorkAtVIPLevel: 'مایل به فعالیت در سطح وی‌آی‌پی نیز هستم',
  ourColleaguesWillContactYouSoon:
    'همکاران ما برای ارتقا سطح شما به زودی با شما در ارتباط خواهند بود',
  image: 'تصویر',
  password2: 'تکرار رمز عبور',
  next: 'مرحله بعد',
  back: 'بازگشت به مرحله قبل',
  registerHasBeenSuccessfully:
    'ثبت نام با موفقیت انجام شد در صورت تایید اطلاعات پیامک ارسال خواهد شد',
  logout: 'خروج',
  forgotPasswordDescription:
    'برای تغییر رمز عبور، شماره موبایل خود را وارد کنید',
  resetPassword: 'بازنشانی رمز عبور',
  newPassword: 'رمز عبور جدید',
  newPassword2: 'تکرار رمز عبور جدید',
  email: 'ایمیل',
  phone: 'تلفن ثابت',
  editAccount: 'ویرایش حساب کاربری',
  changePassword: 'تغییر رمز عبور',
  createPassword: 'ساخت رمز عبور',
  currentPassword: 'رمز عبور فعلی',
  carBrand: 'برند خودرو',
  carType: 'مدل خودرو',
  productionYear: 'سال تولید',
  carColor: 'رنگ خودرو',
  carPlate: 'پلاک خودرو',
  available: 'آماده سرویس دهی',
  unavailable: 'عدم سرویس دهی',
  faceImage: 'تصویر چهره',
  profilePictureUpdatedSuccessfylly: 'تصویر پروفایل با موفقیت بروزرسانی شد',
  profilePictureRemovesSuccessfully: 'تصویر پروفایل با موفقیت حذف شد',
  acceptTermsAndConditions: 'شرایط و قوانین بادپا را می پذیرم',
  conditions:
    'شرایط و مقررات رانندگان:\n\n1. داشتن گواهینامه معتبر رانندگی\n2. حداقل سن 23 سال\n3. نداشتن سوء پیشینه کیفری\n4. داشتن کارت سلامت معتبر\n5. داشتن خودرو مناسب و سالم\n6. رعایت کامل قوانین راهنمایی و رانندگی\n7. برخورد مناسب با مشتریان\n8. رعایت نظم و انضباط کاری\n9. حضور به موقع در محل کار\n10. مراقبت از بار و محموله های مشتریان'
}
